<template>
  <v-container fluid dense>
    <v-card v-if="usaCategorieVariazioni" color="blue lighten-5">
      <v-card-title
        style="padding-top: 5px; padding-bottom:5px; text-overflow: ellipsis;"
        class="text-h6"
        >Variazioni per
        {{ itemVariazioni && itemVariazioni.name }}</v-card-title
      >
      <!-- <v-card-subtitle style="padding-top: 5px; padding-bottom:5px;">{{ itemVariazioni && itemVariazioni.descrizione }}<v-spacer></v-spacer><span v-if="limiteRaggiunto" class="text-right red--text">Limite pezzi raggiunto</span></v-card-subtitle> -->
      <v-card-subtitle style="padding-top: 5px; padding-bottom:5px;"
        ><v-row
          ><v-col>{{ itemVariazioni && itemVariazioni.descrizione }}</v-col
          ><v-col></v-col
          ><v-col v-if="limiteRaggiunto" class="text-right red--text"
            >Limite pezzi raggiunto</v-col
          ></v-row
        ></v-card-subtitle
      >
      <v-tabs
        vertical
        v-model="modelTabs"
        height="83vh"
        background-color="grey lighten-5"
      >
        <v-tab v-show="false"></v-tab>
        <v-tab
          v-for="(v, index) in categorieVariazioni"
          :key="index"
          class="categorie-left"
        >
          {{ v.descrizione }}
        </v-tab>
        <v-tabs-items v-model="modelTabs">
          <v-tab-item></v-tab-item>
          <v-tab-item v-for="(v, index) in categorieVariazioni" :key="index">
            <v-virtual-scroll
              :items="elencoVariazioniDisponibiliTab[v.codice]"
              :item-height="35"
              class="vScrollVariazioniCategoria"
            >
              <template v-slot:default="{ item }">
                <v-list-item dense>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ item.descrizione
                      }}{{
                        mostraPrezzoVariazioni &&
                        deltaPrezzoVariazioni(v, item).trim()
                          ? "  ( " + deltaPrezzoVariazioni(v, item) + ")"
                          : ""
                      }}</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-icon v-if="v.codice === 'preparazioni'">
                    <v-btn-toggle v-model="item.toggle" dense borderless>
                      <v-btn icon @click="preparazioniChange(item)"
                        ><v-icon>mdi-plus-box-outline</v-icon></v-btn
                      >
                    </v-btn-toggle>
                  </v-list-item-icon>
                  <v-list-item-icon v-else>
                    <div v-if="item.usaQuantitaVariazioni" class="text-center">
                      <v-btn
                        v-show="trigger && item.quantita"
                        icon
                        @click="decrementa(item)"
                        ><v-icon x-large>mdi-minus-box-outline</v-icon></v-btn
                      >
                      <span class="ml-3 mr-3 mt-2 text-h6">{{
                        trigger && item.quantita
                      }}</span>
                      <v-btn icon @click="incrementa(item)"
                        ><v-icon x-large>mdi-plus-box-outline</v-icon></v-btn
                      >
                    </div>
                    <v-btn-toggle v-else v-model="item.toggle" dense borderless>
                      <v-btn
                        :disabled="!item.toglie"
                        icon
                        @click="variazioneSub(item)"
                        ><v-icon v-show="item.toglie" color="blue"
                          >mdi-minus-box-outline</v-icon
                        ></v-btn
                      >
                      <v-btn
                        :disabled="!item.aggiunge"
                        icon
                        @click="variazioneAdd(item)"
                        ><v-icon v-show="item.aggiunge" color="green"
                          >mdi-plus-box-outline</v-icon
                        ></v-btn
                      >
                    </v-btn-toggle>
                  </v-list-item-icon>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
    <v-row v-else dense>
      <v-col>
        <v-card color="blue lighten-5">
          <v-card-title
            style="padding-top: 5px; padding-bottom:5px; text-overflow: ellipsis;"
            class="text-h6"
            >Variazioni per
            {{ itemVariazioni && itemVariazioni.name }}</v-card-title
          >
          <v-card-subtitle style="padding-top: 5px; padding-bottom:5px;">{{
            itemVariazioni && itemVariazioni.descrizione
          }}</v-card-subtitle>
          <v-virtual-scroll
            :items="elencoVariazioniDisponibili"
            :item-height="35"
            class="vScrollVariazioni"
          >
            <template v-slot:default="{ item }">
              <v-list-item dense>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ item.descrizione
                    }}{{
                      mostraPrezzoVariazioni &&
                      deltaPrezzoVariazioni(v, item).trim()
                        ? "  ( " + deltaPrezzoVariazioni(v, item) + ")"
                        : ""
                    }}</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn-toggle v-model="item.toggle" dense borderless>
                    <v-btn
                      :disabled="!item.toglie"
                      icon
                      @click="variazioneSub(item)"
                      ><v-icon v-show="item.toglie" color="blue"
                        >mdi-minus-box-outline</v-icon
                      ></v-btn
                    >
                    <v-btn
                      :disabled="!item.aggiunge"
                      icon
                      @click="variazioneAdd(item)"
                      ><v-icon v-show="item.aggiunge" color="green"
                        >mdi-plus-box-outline</v-icon
                      ></v-btn
                    >
                  </v-btn-toggle>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-virtual-scroll>
          <v-list dense>
            <v-divider class="mt-3"></v-divider>
            <v-list-item
              v-for="p of elencoPreparazioniDisponibili"
              :key="p.codice"
              dense
            >
              <v-list-item-content>
                <v-list-item-title
                  >{{ p.descrizione
                  }}{{
                    mostraPrezzoVariazioni && deltaPrezzoPreparazioni(p).trim()
                      ? "  ( " + deltaPrezzoPreparazioni(p) + ")"
                      : ""
                  }}</v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn-toggle v-model="p.toggle" dense borderless>
                  <v-btn icon @click="preparazioniChange(p)"
                    ><v-icon>mdi-plus-box-outline</v-icon></v-btn
                  >
                </v-btn-toggle>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
          <!--           <v-card-actions>
            <v-btn outlined text @click="chiudiVariazioni(itemVariazioni)">ok</v-btn>            
          </v-card-actions> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */
import _ from "lodash";
import { verificaLicenza } from "@/mixins/verificaLicenza.js";
import prodotti from "@/services/prodottiService.js";
import documenti from "@/services/documentiService.js";
import configurazioni from "@/services/configurazioniService.js";

export default {
  props: {
    idProdotto: { type: String, default: "" },
    idmenu: { type: String, default: "" },
    chiave: { type: String, default: "not-set" },
    // menuScontrino: Object
  },
  mixins: [verificaLicenza],
  data: () => ({
    tipoColoreGruppo: "eccesso",
    menu: null,
    trigger: 1,
    menuCreati: [],
    itemVariazioni: null,
    itemMenuSelezionato: null,
    variazioniSelezionate: [],
    preparazioniSelezionate: [],
    elencoVariazioni: [],
    elencoPreparazioni: [],
    elencoVariazioniDisponibili: [],
    elencoPreparazioniDisponibili: [],
    tastiMenu: [],
    tastoMenu: 0,
    idMenu: "",
    menuTotali: null,
    impostazioniMenu: null,
    menuSceltiAffiancato: false,
    categorieVariazioni: [],
    usaCategorieVariazioni: false,
    elencoVariazioniDisponibiliTab: {},
    modelTabs: null,
    separaVaziazioniNegative: true,
    labelVariazioniNegative: "Variazioni -",
    labelPreparazioni: "Preparazioni",
    maxVariazioni: 0,
    limiteRaggiunto: false,
  }),
  async created() {
    const menu = await configurazioni.getConfigurazione("menu");
    this.elencoVariazioni = menu.variazioni;
    this.elencoPreparazioni = menu.preparazioni;
    this.impostazioniMenu = menu.impostazioni;
    this.menuSceltiAffiancato = menu.impostazioni.menuSceltiAffiancato;

    this.usaCategorieVariazioni = menu.impostazioni.usaCategorieVariazioni;

    this.separaVaziazioniNegative = menu.impostazioni.separaVaziazioniNegative;
    this.labelVariazioniNegative = menu.impostazioni.labelVariazioniNegative;
    this.labelPreparazioni = menu.impostazioni.labelPreparazioni;

    if (this.usaCategorieVariazioni) {
      let categorieVariazioni = menu.variazioni.map((x) => {
        return { codice: x.codice, descrizione: x.descrizione };
      });
      if (this.separaVaziazioniNegative) {
        this.categorieVariazioni.push({
          codice: "variazioniMeno",
          descrizione: this.labelVariazioniNegative,
        });
        this.categorieVariazioni = this.categorieVariazioni.concat(
          _.sortBy(_.uniqBy(categorieVariazioni, "codice"), ["codice"])
        );
      } else {
        this.categorieVariazioni = _.sortBy(
          _.uniqBy(categorieVariazioni, "codice"),
          ["codice"]
        );
      }
      this.categorieVariazioni.push({
        codice: "preparazioni",
        descrizione: this.labelPreparazioni,
      });

      this.elencoVariazioniDisponibiliTab = {};
      for (let c of this.categorieVariazioni) {
        this.elencoVariazioniDisponibiliTab[c.codice] = [];
      }
      // this.elencoVariazioniDisponibiliTab['preparazioni'] = []
    }
  },
  async mounted() {
    await this.gestioneToken();
    const payload = await configurazioni.takeMemoriaCondivisa(this.chiave);
    this.variazioniSelezionate = [];
    this.preparazioniSelezionate = [];
    if (payload) {
      this.variazioniSelezionate = payload.prodotto.variazioni || [];
      this.preparazioniSelezionate = payload.prodotto.preparazioni || [];
    }
    await this.apriVariazioni(this.idProdotto);
    setTimeout(() => {
      this.modelTabs = 1;
    }, 5);
  },
  watch: {
    async chiave(value) {
      console.log("watch chiave", value);
      const payload = await configurazioni.takeMemoriaCondivisa(this.chiave);
      this.variazioniSelezionate = [];
      this.preparazioniSelezionate = [];
      if (payload) {
        this.variazioniSelezionate = payload.prodotto.variazioni || [];
        this.preparazioniSelezionate = payload.prodotto.preparazioni || [];
      }
      await this.apriVariazioni(this.idProdotto);
      setTimeout(() => {
        this.modelTabs = 1;
      }, 5);
    },
  },
  computed: {
    mostraPrezzoVariazioni() {
      return this.impostazioniMenu?.mostraPrezzoVariazioni || false;
    },
    totVariazioni() {
      return this.variazioniSelezionate.length;
    },
    /*       usaQuantitaVariazioni() {
        return this.impostazioniMenu?.usaQuantitaVariazioni || false
      } */
  },
  methods: {
    async decrementa(item) {
      if ((item.quantita || 0) > 0) {
        item.quantita = item.quantita - 1;
        this.limiteRaggiunto = false;
        await this.variazioneDelta(item);
        this.trigger++;
      }
    },
    async incrementa(item) {
      if (!this.limiteRaggiunto) {
        item.quantita = (item.quantita || 0) + 1;
        await this.variazioneDelta(item);
        this.limiteRaggiunto =
          this.maxVariazioni && this.totVariazioni >= this.maxVariazioni;
        this.trigger++;
      }
    },
    deltaPrezzoVariazioni(categoria, variazione) {
      const piu = (variazione.deltaPrezzoPiu || 0).toFixed(2);
      const meno = (variazione.deltaPrezzoMeno || 0).toFixed(2);
      const isMeno = categoria.codice === "variazioniMeno";
      // return `${variazione.deltaPrezzoPiu && !isMeno ? '+' + piu : ''} ${variazione.deltaPrezzoPiu && variazione.deltaPrezzoMeno ? '/' : ''} ${variazione.deltaPrezzoMeno && isMeno ? '-' + meno : ''}`
      return `${variazione.deltaPrezzoPiu && !isMeno ? "+" + piu : ""}${
        variazione.deltaPrezzoMeno && isMeno ? meno : ""
      }`;
    },
    deltaPrezzoPreparazioni(preparazione) {
      const delta = (preparazione.deltaPrezzo || 0).toFixed(2);
      return `${preparazione.deltaPrezzo ? "+" + delta : ""}`;
    },
    async inviaAggiornamento() {
      // const chiave = `variazioni_${this.chiave}`
      const payload = {
        item: this.itemVariazioni,
        variazioni: this.variazioniSelezionate,
        preparazioni: this.preparazioniSelezionate,
      };
      await configurazioni.setMemoriaCondivisa(this.chiave, payload);
    },
    async apriVariazioni(idProdotto) {
      // Caricare le variazioni per il prodotto
      const prodotto = await prodotti.getProdotto(idProdotto);
      if (!prodotto) {
        alert("Attenzione! Prodotto non trovato in archivio...");
        return;
      }
      this.maxVariazioni = _.get(prodotto, "custom.maxVariazioni", 0);
      this.itemVariazioni = {
        codice: idProdotto,
        descrizione: prodotto.descrizione,
        name: prodotto.descrizione,
        presenzaVariazioni: true, // verificare
        quantita: 1, // verificare
        unitaMisura: _.get(prodotto, "magazzino.unitaMisura"),
        stampa: [], // verificare
      };
      const categorie = prodotto.statistici;
      let elenco = categorie
        ? Object.values(categorie).map((x) => x.codice)
        : [];
      elenco.push(prodotto.datiFiscali.reparto.codice);

      // elenco categorie da visualizzare
      // TODO: Gestire impostazione: Se prodotto ha variazioni --> unisce o sostituisce a quelle delle categorie...
      // console.log('elencoVariazioni', this.elencoVariazioni)
      let variazioniDisponibili = [];
      let preparazioniDisponibili = [];
      variazioniDisponibili = variazioniDisponibili.concat(
        prodotto.variazioni || []
      );
      preparazioniDisponibili = preparazioniDisponibili.concat(
        prodotto.preparazioni || []
      );
      let variazioniPerCategoria = this.elencoVariazioni.filter(
        (x) => _.intersection(elenco, x.elencoCategorie).length > 0
      );
      let vv = variazioniPerCategoria.map((x) => x.variazioni);
      vv = _.flatten(vv);
      variazioniDisponibili = _.unionBy(variazioniDisponibili, vv, "codice");

      let preparazioniPerCategoria = this.elencoPreparazioni.filter(
        (x) => _.intersection(elenco, x.elencoCategorie).length > 0
      );
      let pp = preparazioniPerCategoria.map((x) => x.preparazioni);
      pp = _.flatten(pp);
      preparazioniDisponibili = _.unionBy(
        preparazioniDisponibili,
        pp,
        "codice"
      );

      // (verificare) Deve marcare come selezionati i prodotti da distinta base --> posso solo toglierli o sostituirli
      const prodottiDistinta = await documenti.getProdottiDistinta(prodotto);
      // Se una variazione ha la possibilità di essere tolta, verifica la DB per vedere se presente. Non posso togliere un ingrediente non presente
      // Stessa cosa in aggiunta. Non posso aggiungere un ingrediente già presente

      for (let v of variazioniDisponibili) {
        const pdb = prodottiDistinta.find((x) => x.codice === v.codice);
        if (v.toglie) {
          if (!pdb) {
            // Se non è presente non si può togliere
            v.toglie = false;
          }
        }
        if (v.aggiunge) {
          if (pdb) {
            // Se è già presente non si può aggiungere (per "doppio" fare ingrediente a parte che sostituisce singolo, es. doppia mozzarella, altrimenti sembra un errore)
            v.aggiunge = false;
          }
        }

        if (v.usaQuantitaVariazioni) {
          const itms = this.variazioniSelezionate.filter(
            (x) => x.codice === v.codice
          );
          if (itms) {
            v.quantita = (v.quantita || 0) + itms.length;
          }
        } else {
          const itm = this.variazioniSelezionate.find(
            (x) => x.codice === v.codice
          );
          if (itm) {
            v.toggle = itm.segno === "+" ? 1 : 0;
          } else {
            v.toggle = null; // Due scelte, nessuna selezionata
          }
        }
      }
      for (let p of preparazioniDisponibili) {
        const itm = this.preparazioniSelezionate.find(
          (x) => x.codice === p.codice
        );
        p.toggle = !!itm ? 0 : 1; // false: Una scelta, non selezionata
      }

      // ---------------------------------------------------
      this.elencoVariazioniDisponibili = variazioniDisponibili.filter(
        (x) => x.aggiunge || x.toglie
      ); // Viene nascosto se non può essere gestito
      this.elencoVariazioniDisponibili = _.sortBy(
        this.elencoVariazioniDisponibili,
        ["descrizione"]
      );
      this.elencoPreparazioniDisponibili = preparazioniDisponibili;
      this.elencoPreparazioniDisponibili = _.sortBy(
        this.elencoPreparazioniDisponibili,
        ["descrizione"]
      );

      if (this.usaCategorieVariazioni) {
        for (let c of this.categorieVariazioni) {
          if (this.separaVaziazioniNegative) {
            let elenco = this.elencoVariazioniDisponibili.filter(
              (x) => x.codiceCategoria === c.codice
            );
            for (let el of elenco) {
              el.deltaPrezzoMeno = -el.deltaPrezzoMeno;
              if (el.usaQuantitaVariazioni) {
                el.quantita = el.quantita || 0;
                if (el.toglie && el.quantita === 0) {
                  el.quantita = 1;
                }
              }
              if (el.aggiunge) {
                this.elencoVariazioniDisponibiliTab[c.codice].push(el);
              } else {
                this.elencoVariazioniDisponibiliTab["variazioniMeno"].push(el);
              }
            }
          } else {
            this.elencoVariazioniDisponibiliTab[
              c.codice
            ] = this.elencoVariazioniDisponibili.filter(
              (x) => x.codiceCategoria === c.codice
            );
            for (let el of this.elencoVariazioniDisponibiliTab[c.codice]) {
              el.deltaPrezzoMeno = -el.deltaPrezzoMeno;
            }
          }
        }
        if (this.elencoPreparazioniDisponibili.length > 0) {
          this.elencoVariazioniDisponibiliTab[
            "preparazioni"
          ] = this.elencoPreparazioniDisponibili;
        } else {
          this.categorieVariazioni = this.categorieVariazioni.filter(
            (x) => x.codice !== "preparazioni"
          );
        }
        if (
          this.elencoVariazioniDisponibiliTab["variazioniMeno"].length === 0
        ) {
          this.categorieVariazioni = this.categorieVariazioni.filter(
            (x) => x.codice !== "variazioniMeno"
          );
        }
      }
      this.trigger++;
    },
    async variazioneAdd(v) {
      await this.$nextTick();
      let item = this.itemVariazioni;
      const daAggiungere = {
        segno: "+",
        codice: v.codice,
        descrizione: v.descrizione,
        deltaPrezzo: v.deltaPrezzoPiu,
        deltaQuantita: v.quantitaPiu || 0,
        stampa: item.stampa,
      };
      let vSel = this.variazioniSelezionate || [];
      vSel = vSel.filter((x) => x.codice !== v.codice);
      if (v.toggle === 1) {
        vSel.push(daAggiungere);
      }
      this.variazioniSelezionate = vSel;
      await this.inviaAggiornamento();
      this.trigger++;
    },
    async variazioneSub(v) {
      await this.$nextTick();
      let item = this.itemVariazioni;
      const daAggiungere = {
        segno: "-",
        codice: v.codice,
        descrizione: v.descrizione,
        deltaPrezzo: v.deltaPrezzoMeno,
        deltaQuantita: v.quantitaMeno || 0,
        stampa: item.stampa,
      };
      let vSel = this.variazioniSelezionate || [];
      vSel = vSel.filter((x) => x.codice !== v.codice);
      if (v.toggle === 0) {
        vSel.push(daAggiungere);
      }
      this.variazioniSelezionate = vSel;
      await this.inviaAggiornamento();
      this.trigger++;
    },
    async variazioneDelta(v) {
      await this.$nextTick();
      let item = this.itemVariazioni;
      const daAggiungere = {
        segno: "+",
        codice: v.codice,
        descrizione: v.descrizione,
        deltaPrezzo: v.deltaPrezzoPiu,
        deltaQuantita: v.quantitaPiu || 0,
        stampa: item.stampa,
      };
      let vSel = this.variazioniSelezionate || [];
      vSel = vSel.filter((x) => x.codice !== v.codice);
      for (let i = 0; i < v.quantita; i++) {
        vSel.push(daAggiungere);
      }
      this.variazioniSelezionate = vSel;
      await this.inviaAggiornamento();
      this.trigger++;
    },
    async preparazioniChange(p) {
      await this.$nextTick();
      let item = this.itemVariazioni;
      const daAggiungere = {
        segno: "+",
        codice: p.codice,
        descrizione: p.descrizione,
        deltaPrezzo: p.deltaPrezzo,
        stampa: item.stampa,
      };
      let vPrep = this.preparazioniSelezionate || [];
      vPrep = vPrep.filter((x) => x.codice !== p.codice);
      if (p.toggle === 0) {
        vPrep.push(daAggiungere);
      }
      this.preparazioniSelezionate = vPrep;
      await this.inviaAggiornamento();
      this.trigger++;
    },
  },
};
</script>

<style scoped>
/* TODO: Da sistemare, dovrebbero essere dinamici ma attualmente il componente virtual scoller non prende dinamicamente l'altezza */
.vScrollH {
  height: 81vh;
  background-color: white;
}

.vScrollH2 {
  height: 40vh;
  background-color: white;
}

.vScrollVariazioni {
  height: 50vh;
  background-color: white;
}
.categorie-left {
  justify-content: left;
}

.vScrollVariazioniCategoria {
  height: 85vh;
  background-color: white;
}
</style>
